<app-navbar title="Historia: {{ data.editBy }} {{ data.editAt }}">
	<!-- <button
		class="me-2"
		mat-raised-button
		color="warn"
		routerLink="../settlementBonus/"
	>
		<i class="fas fa-chevron-left"></i>
		Powrót
	</button> -->
</app-navbar>

<div class="container">
	<div class="form-floating my-4">
		<ng-select
			name="settlementBonusNameId"
			[(ngModel)]="data.json.settlementBonusNameId"
			[multiple]="false"
			placeholder="Typ"
			[disabled]="pageFunction !== 'add' || !editable"
		>
			<ng-option *ngFor="let item of settlementBonusName" [value]="item.id">{{ item.name }}</ng-option>
		</ng-select>
	</div>
	<div class="form-floating my-4">
		<ng-select
			name="ownerId"
			[(ngModel)]="data.json.ownerId"
			[multiple]="false"
			placeholder="Imie Nazwisko"
			[disabled]="data.json.confirmButton || !editable"
		>
			<ng-option *ngFor="let item of drivers" [value]="item.id"
				>{{ item.last_name }} {{ item.first_name }}
			</ng-option>
		</ng-select>
	</div>
	<div class="form-floating my-4">
		<input
			type="date"
			name="date"
			[(ngModel)]="data.json.date"
			class="form-control"
			[disabled]="data.json.confirmButton || !editable"
		/>
		<label for="date">Data</label>
	</div>
	<div class="form-floating my-4">
		<ng-select
			name="vehicleId"
			[(ngModel)]="data.json.vehicleId"
			[multiple]="false"
			placeholder="Pojazd"
			[disabled]="data.json.confirmButton || !editable"
		>
			<ng-option *ngFor="let item of vehicles" [value]="item.id"
				>{{ item.name }} {{ item.registrationNumber }}
			</ng-option>
		</ng-select>
	</div>

	<div class="form-floating my-4">
		<input
			type="text"
			[(ngModel)]="data.json.comment"
			name="comment"
			class="form-control"
			[disabled]="data.json.confirmButton || !editable"
		/>
		<label for="comment">Komentarz</label>
	</div>
	<div class="form-floating my-4">
		<input
			type="number"
			[(ngModel)]="data.json.value"
			name="value"
			class="form-control"
			[disabled]="data.json.confirmButton || !editable"
		/>
		<label for="discountValue">Wartość</label>
	</div>
	<ng-select
		name="valueCurrencyId"
		[(ngModel)]="data.json.valueCurrencyId"
		[multiple]="false"
		placeholder="Wartość waluta"
		[disabled]="data.json.confirmButton || !editable"
	>
		<ng-option *ngFor="let item of currency" [value]="item.id">{{ item.name }}</ng-option>
		<label for="discountValue">Wartość waluta</label>
	</ng-select>
	<ng-select
		name="settlementCurrencyId"
		[(ngModel)]="data.json.settlementCurrencyId"
		[multiple]="false"
		placeholder="Rozliczenie waluta"
		[disabled]="data.json.confirmButton || !editable"
	>
		<ng-option *ngFor="let item of currency" [value]="item.id">{{ item.name }}</ng-option>
		<label for="discountValue">Wartość waluta</label>
	</ng-select>
	<div class="form-floating my-4">
		<ng-select
			name="confirmPerson"
			[(ngModel)]="data.json.confirmPerson"
			[multiple]="false"
			placeholder="Osoba, która ma zatwierdzić dodatek/potrącenie"
			[disabled]="data.json.confirmButton || !editable"
		>
			<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
		</ng-select>
	</div>
	<div class="form-floating my-4">
		ZATWIERDZENIE DODATKU i POTRĄCENIA
		<button
			type="button"
			class="btn"
			name="confirm"
			[ngClass]="{
				'btn-success': data.json.confirmButton,
				'btn-outline-danger': !data.json.confirmButton,
			}"
			[disabled]="editable"
		>
			Zatwierdź
		</button>
		{{ data.json.confirm }}
	</div>
	<div class="form-floating my-4" *ngIf="['3'].includes(data.json.settlementBonusNameId)">
		ZATWIERDZENIE WARSZTAT
		<button
			type="button"
			class="btn"
			name="confirm"
			[ngClass]="{
				'btn-success': data.json.workshopButton,
				'btn-outline-danger': !data.json.workshopButton,
			}"
			[disabled]="editable"
		>
			Zatwierdź
		</button>
		{{ data.json.workshop }}
		<div class="form-floating my-4">
			<input type="text" [(ngModel)]="data.json.workshopComment" name="workshopComment" class="form-control" />
			<label for="workshopComment">Komentarz Warsztat</label>
		</div>
	</div>
</div>
<div class="container col-auto my-4">
	<fieldset [disabled]="!editable">
		<mat-table #dataTable [(dataSource)]="data.json.terms" matSort matSortActive="month" matSortDirection="asc">
			<ng-container matColumnDef="lp">
				<mat-header-cell *matHeaderCellDef mat-sort-header> LP </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="month">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Miesiąc </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<input
						[disabled]="element.isSettled === '1'"
						type="date"
						name="date_{{ i }}"
						[(ngModel)]="element.month"
						class="form-control"
					/>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="value">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Wartość: {{ labelValue }} </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<input
						[disabled]="element.isSettled === '1'"
						type="number"
						name="number_{{ i }}"
						step="0.01"
						[(ngModel)]="element.value"
						class="form-control"
					/>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="comment">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Komentarz </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<input
						[disabled]="element.isSettled === '1'"
						type="text"
						name="text_{{ i }}"
						[(ngModel)]="element.comment"
						class="form-control"
					/>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="toDelete">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Do usunięcia </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index"
					><button
						[disabled]="element.isSettled === '1'"
						class="btn"
						[ngClass]="{
							'btn-danger': element.toDelete,
							'btn-outline-danger': !element.toDelete,
						}"
					>
						Do usunięcia
					</button></mat-cell
				>
			</ng-container>
			<ng-container matColumnDef="dietKind">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<span *ngIf="data.json.settlementBonusNameId === '1'">Dieta</span>
				</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<select
						[disabled]="element.isSettled === '1'"
						type="text"
						class="form-select"
						name="diet_{{ i }}"
						*ngIf="data.json.settlementBonusNameId === '1'"
						[(ngModel)]="element.dietKind"
					>
						<option [value]="element.id" [disabled]="element.disabled" *ngFor="let element of dietKind">
							{{ element.name }}
						</option>
					</select>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
		</mat-table>
		<div class="d-grid gap-2">
			<button mat-raised-button color="primary" [disabled]="!editable">
				<i class="fas fa-plus"></i>
				Dodaj pozycję
			</button>
		</div>
	</fieldset>
</div>
